import { Link, useLocation } from 'react-router-dom';
import { getIndividualReportURL } from '../../../utils/getIndividualReportURL';
import { usePostHog } from '@posthog/react';

interface StudentNameLinkProps {
  studentId: string | null | undefined;
  classIds?: string[];
  className?: string;
  /** Names the call site: rendered as the DOM id, and sent as `source` on the `navigated_to_isr` event. */
  id?: string;
  children: React.ReactNode;
}

export const StudentNameLink = ({ studentId, classIds, className, id, children }: StudentNameLinkProps) => {
  const posthog = usePostHog();
  const location = useLocation();
  if (!studentId) return <span>{children}</span>;
  return (
    <Link
      id={id}
      to={`/progress/${getIndividualReportURL({
        studentId,
        classIds,
      })}`}
      state={{ isrReturnTo: `${location.pathname}${location.search}${location.hash}` }}
      className={['tw-text-blue-700 tw-underline ph-no-autocapture', className].filter(Boolean).join(' ')}
      onClick={() => {
        // `ph-no-autocapture` above keeps PostHog off this link on purpose — the text is a student's
        // name and autocapture sends element text — so this manual call is the only event the click
        // produces, and `source` the only place the originating list can be named. Omitted entirely
        // when the call site passes no `id`, so the unnamed ones keep emitting what they always have.
        posthog.capture('navigated_to_isr', id ? { source: id } : undefined);
      }}
    >
      {children}
    </Link>
  );
};

export default StudentNameLink;
